// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ImageCarousel_carousel__jvvdW","carousel_arrowLeft":"ImageCarousel_carousel_arrowLeft__MNsQq","carousel_arrowRight":"ImageCarousel_carousel_arrowRight__CUXgS"};